import { orpc } from "@/utils/orpc.client";
import type { FeaturePageEntityType } from "@garimpa/lib/featurePage";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

export function getFeaturePageBacklinksQueryOptions(input: {
  entityType: FeaturePageEntityType;
  catalogId: string;
  workId?: string;
  locale: ViewerLocale;
}) {
  return {
    ...orpc.featurePages.getEntityEditorialContext.queryOptions({ input }),
    staleTime: 10 * 60 * 1_000,
    gcTime: 30 * 60 * 1_000,
  };
}
